import React, { FC } from 'react';

const FreshRelevanceSmartBlock: FC<{
  readonly uniqueId: string | unknown;
  index: number;
  showInitial: boolean;
}> = ({ uniqueId, index, showInitial }) => {
  let className = '';
  if (index === 0 && showInitial) {
    className = 'block pb-8';
  } else if (index === 0 && !showInitial) {
    className = 'hidden pb-8';
  } else if (index === 1 && showInitial) {
    className = 'hidden pb-8';
  } else if (index === 1 && !showInitial) {
    className = 'block pb-8';
  }
  return <div id={uniqueId as string} className={className} />;
};

export default FreshRelevanceSmartBlock;
